import { Link } from 'react-router-dom';

export default function CategorySelection() {
  const categories = [
    {
      icon: 'ri-gift-line',
      title: '年会費無料',
      description: 'コスト0円で持てる',
      cards: '三井住友カード、大手ECモール系カード',
      link: '/free',
      color: 'from-emerald-500 to-teal-600',
      bgColor: 'from-emerald-50 to-teal-50',
    },
    {
      icon: 'ri-percent-line',
      title: '高還元率',
      description: 'ポイントがザクザク貯まる',
      cards: '高還元率カード、大手ECモール系カード',
      link: '/highreturn',
      color: 'from-amber-500 to-orange-600',
      bgColor: 'from-amber-50 to-orange-50',
    },
    {
      icon: 'ri-time-line',
      title: '即日発行',
      description: '今日中にカードが欲しい',
      cards: '三井住友カード、地方銀行系スピード発行カード',
      link: '/instant',
      color: 'from-rose-500 to-pink-600',
      bgColor: 'from-rose-50 to-pink-50',
    },
    {
      icon: 'ri-graduation-cap-line',
      title: '学生向け',
      description: '学生でも作りやすい',
      cards: 'dカード GOLD U、三井住友カード',
      link: '/student',
      color: 'from-sky-500 to-cyan-600',
      bgColor: 'from-sky-50 to-cyan-50',
    },
    {
      icon: 'ri-shield-check-line',
      title: '審査が不安な方',
      description: 'デポジット型で安心',
      cards: 'デポジット型クレジットカード',
      link: '/nexus',
      color: 'from-violet-500 to-purple-600',
      bgColor: 'from-violet-50 to-purple-50',
    },
  ];

  return (
    <section className="py-12 sm:py-16 md:py-20 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* ヘッダー */}
        <div className="text-center mb-10 sm:mb-12 md:mb-16">
          <span className="inline-block bg-gradient-to-r from-teal-100 to-emerald-100 text-teal-700 px-4 sm:px-5 py-2 rounded-full text-xs sm:text-sm font-bold mb-4 sm:mb-6 shadow-sm">
            🎯 目的別に選ぶ
          </span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-5 tracking-tight px-4">
            あなたの目的から
            <br className="sm:hidden" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal-600 to-emerald-600">最適なカードを探す</span>
          </h2>
          <p className="text-base sm:text-lg text-gray-500 max-w-2xl mx-auto px-4">
            利用目的に合わせて、最適なクレジットカードをご提案します
          </p>
        </div>

        {/* カテゴリーグリッド */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6 md:gap-8">
          {categories.map((category, index) => (
            <Link
              key={index}
              to={category.link}
              className="group cursor-pointer"
            >
              <div className={`relative bg-gradient-to-br ${category.bgColor} rounded-2xl sm:rounded-3xl p-6 sm:p-8 hover:shadow-2xl transition-all duration-500 border border-gray-100 hover:border-transparent overflow-hidden hover:-translate-y-2`}>
                {/* 背景装飾 */}
                <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-white/50 to-transparent rounded-full blur-2xl"></div>
                <div className="absolute bottom-0 left-0 w-24 h-24 bg-gradient-to-tr from-white/50 to-transparent rounded-full blur-xl"></div>

                {/* アイコン */}
                <div className={`relative w-14 h-14 sm:w-16 sm:h-16 bg-gradient-to-br ${category.color} rounded-xl sm:rounded-2xl flex items-center justify-center mb-4 sm:mb-6 shadow-lg group-hover:scale-110 group-hover:rotate-6 transition-all duration-500`}>
                  <i className={`${category.icon} text-white text-2xl sm:text-3xl`}></i>
                </div>

                {/* コンテンツ */}
                <div className="relative">
                  <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2 sm:mb-3 group-hover:text-teal-600 transition-colors">
                    {category.title}
                  </h3>
                  <p className="text-gray-600 text-sm sm:text-base mb-4 sm:mb-5 leading-relaxed">
                    {category.description}
                  </p>
                  <div className="bg-white/80 backdrop-blur-sm rounded-lg sm:rounded-xl p-3 sm:p-4 mb-4 sm:mb-5 border border-gray-200">
                    <p className="text-xs text-gray-500 mb-1 font-medium">おすすめカード</p>
                    <p className="text-sm sm:text-base text-gray-700 font-semibold leading-snug">
                      {category.cards}
                    </p>
                  </div>
                  <div className="flex items-center gap-2 text-teal-600 font-bold group-hover:gap-4 transition-all text-sm sm:text-base">
                    <span>詳しく見る</span>
                    <i className="ri-arrow-right-line text-lg"></i>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* 追加CTA */}
        <div className="mt-10 sm:mt-16 text-center">
          <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl sm:rounded-3xl p-6 sm:p-10 max-w-3xl mx-auto border border-gray-200 shadow-lg">
            <span className="text-3xl sm:text-4xl mb-3 sm:mb-4 block">🤔</span>
            <h3 className="text-lg sm:text-2xl font-bold text-gray-900 mb-2 sm:mb-3 px-4">
              どれを選べばいいか分からない？
            </h3>
            <p className="text-gray-600 mb-5 sm:mb-8 text-sm sm:text-base px-4">
              簡単な質問に答えるだけで、あなたにぴったりのカードが見つかります
            </p>
            <Link
              to="/diagnosis"
              className="inline-flex items-center justify-center gap-2 bg-gradient-to-r from-teal-600 to-emerald-600 hover:from-teal-700 hover:to-emerald-700 text-white font-bold px-6 sm:px-8 py-3 sm:py-4 rounded-full transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer text-sm sm:text-base w-full sm:w-auto"
            >
              <i className="ri-questionnaire-line text-lg sm:text-xl"></i>
              カード診断を始める
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
